import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
//import { Router } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Role } from '../../const';
import { SharedService } from '../../shared/services/shared.service';
import { DtoSector } from '../../models/sector.model';
import { DtoNotifications,DtoNotificationCount } from '../../models/notifications.model';
import { SectorService } from '../sector/sector.service';
import { PackageService } from '../package-center/package/package.service';
import { DtoModuleSubcategory, DtoSubCategory, PackageInformation, SubCategoryGrouping} from '../../models/package-center.model';
import { HttpErrorResponse } from '@angular/common/http';
import {ToastrService } from 'ngx-toastr';
import { NotificationService } from '../user-center/notifications/notification.service';
import { LoginService } from '../login/login.service';
import { DtoUser } from '../../models/user-center.model';
import { SchoolService } from '../school/school.service';
import { ClientAccountDetails } from '../../models/mat-account.model';
import { MsalService } from '@azure/msal-angular';
import { ContrastMode } from '../../models/contrast-mode.enum';
import { PowerBiReportService } from '../powerbi-report/powerbi-report.service';
import { Subscription } from 'rxjs';
import { DtoUserProfile, DtoUserReportView } from '../../models/userProfile.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html'
})
export class SidemenuComponent implements OnInit {
  userRole: string[] = [];
  roles = Role;
  currentRoute: string = '';
  sideMenu = SideMenu;
  userName: string = '';
  selectedSector: number = 0;
  sectors: DtoSector[] = [];
  sectorName: string = "";
  package: PackageInformation = {} as PackageInformation;
  assignedPackageId: number = 0;
  showDynamicMenu = false;

  startupSubCategoryId: number|null=null;
  startupSubPageName: string|null=null;

  selectedSubCategory: DtoSubCategory | null = null;
  prevSelectedSubCategory: DtoSubCategory | null = null;
  
  loggedInAsSchoolUser: boolean = false;
  roleName: string = "";
  notificationCount: number = 0;
  // systemMessage: string|null = null;
  sectorId: number = 0;
  userId: number = 0;
  schoolId: string = "";
  url: string = "";
  textContent: string = 'Josephine Gabriella Charlotte Isabella';
  longText: string = 'Josephine Gabriella Charlotte Isabella';
  shortText: string = 'XXXXXXX XXXX';
  isTextLong: boolean = false;
  maxLength: number = 15;
  sectorOfAccountAdmin: number[] = [];
  matAccountList: ClientAccountDetails[] = [];
  AccountOrSchoolLogo:string = "";
  AccountLogoShape:string='';
  AccountOrSchoolLogoRef:string|null = "";
  ContrastMode = ContrastMode;
  UserPreferenceSubscription: Subscription | undefined;
  ReportViewSubscription: Subscription | undefined;

  constructor(private router: Router,
    private sharedService: SharedService, 
    private sectorService: SectorService,
    private packageService: PackageService, 
    private toasterService: ToastrService,
    private cdr: ChangeDetectorRef, 
    private notificationService: NotificationService,
    private loginService: LoginService, 
    private schoolService: SchoolService,
    private msalService: MsalService,
    private reportService: PowerBiReportService,
    private snackBar: MatSnackBar
  ) {
    this.getClaims();
    this.getSectors();
    this.msalService.initialize();
  }
  
  ngOnInit(): void {
    this.UserPreferenceSubscription = this.sharedService.userPreference$
      .subscribe(([userProfile, hint]) => {
        this.handleUserProfileChange(userProfile, hint);
      });

    this.ReportViewSubscription= this.sharedService.userReportView$
      .subscribe(([reportView, hint]) => {
        this.handleReportViewChanges(reportView, hint);
      });

    this.currentRoute = this.router.url;

    this.getClaims();
    this.initUserContetext()

    window.onpopstate = (event) => {
      this.handleBackButton();
      history.pushState(null, '', location.href);
    };
    
    this.setClientLogo(null); 

    this.sharedService.loadReportForSelectedClientAccount.subscribe((data) => {
      if(data){
        this.getPackageByPackageId(Number(sessionStorage.getItem('package_of_client_account')));
        this.showDynamicMenu = true;
        this.setClientLogo(sessionStorage.getItem('client_reference'));
        return;
      }
      else{
        this.setClientLogo(null);
      }
    });

    this.sharedService.loadReportForSelectedIndividualSchool.subscribe((data) => {
      if(data){
        const packageId = Number(sessionStorage.getItem('package_of_client_account'));
        
        this.getPackageByPackageId(packageId);
        this.showDynamicMenu = true;
        this.setClientLogo(sessionStorage.getItem('client_reference'));
        return;
      }
      else{
        this.setClientLogo(null);
      }
    });

    this.sharedService.profileUploaded.subscribe((data) => {
      if(data){
        this.getUserDetails();
      }
    });

    this.sharedService.loadReport.subscribe((data) => {
      if(data){
        this.getPackageForSchoolUsers();
        this.setClientLogo(sessionStorage.getItem('client_reference'));
      }
      else{
        this.setClientLogo(null);
      }
    });

    this.sharedService.sectorValue$.subscribe(value => {
      this.selectedSector = parseInt(value!);
      if(this.userRole.includes(this.roles.SuperAdmin) || this.userRole.includes(this.roles.AccountAdmin)){
        if(this.selectedSector > 0){
          this.currentRoute = this.sideMenu.Sector;
          this.showDynamicMenu = false;
        }
        this.sectorName = this.sectors.find(s => s.sectorId === this.selectedSector)?.sectorName!;
        if(Number(sessionStorage.getItem('sector')) == 1){
          this.currentRoute = this.sideMenu.UserCenter;
          this.router.navigate(['/userCenter'])
        }
        else if(Number(sessionStorage.getItem('sector')) > 1){
          this.currentRoute = this.sideMenu.AccountAdminCenter;
          this.router.navigate(['/accountAdminCenter']);
        }
      }
    });
    this.isTextLong = this.textContent.length > this.maxLength;
    this.msalService.initialize();
    this.sharedService.updatedNotification.subscribe((data) => {
      if(data.data){
        this.fetchNotifications(
          sessionStorage.getItem('user_email')!,
          data.holding
        );
      }
    });
  }

  ngOnDestroy() {
    // Clean up by removing the event listener when the component is destroyed
    window.onpopstate = null;
  }

  handleBackButton() {
    // Call your custom function to handle the back button press
    this.handleBack()
    
    // You can even programmatically navigate to a different route
    //this.router.navigate(['/some-other-route']);
    
    // Or prevent navigation by pushing a state back into history
    //this.location.replaceState('/');  // Replace the current state to prevent going back
  }

    toggleExpandable(siblings: SubCategoryGrouping[]|null, subCategoryList: SubCategoryGrouping) {
      
      siblings!.forEach((x)=>{
          
          if(x===subCategoryList)
            subCategoryList.isExpanded = !subCategoryList.isExpanded;
          else
            x.isExpanded=false;
      })
      this.cdr.detectChanges();
    }

    getSubCategoryGrouping(subCategories: DtoSubCategory[]):SubCategoryGrouping[]{
      const groupMap = new Map<string, SubCategoryGrouping>();
      const result: SubCategoryGrouping[] = [];
      var input = subCategories;
      for (const item of input) {
        if (item.subCategoryDisplayName === null) {
          // Push ungrouped items directly
          result.push({
            groupName: null,
            isExpanded:false,
            items:[item]
          } as SubCategoryGrouping);
        } else {
          // Group by groupName
          if (!groupMap.has(item.subCategoryDisplayName)) {
            var newGroup = {
              isExpanded:(result.length==1),
              groupName: item.subCategoryDisplayName,
              items: []
            } as SubCategoryGrouping;
            groupMap.set(item.subCategoryDisplayName, newGroup);
            result.push(newGroup);
          }
          groupMap.get(item.subCategoryDisplayName)!.items.push(item);
        }
      }
  
      return result;
    }
    
  setClientLogo(clientReference: string|null){
    var clientRefType = 'CA'; //CA
    clientReference = clientReference || null;

    if(!clientReference){
      clientRefType = sessionStorage.getItem("orgType")??"";
      clientReference = sessionStorage.getItem("orgRef");
    } 

    if(this.AccountOrSchoolLogoRef==clientReference)
      return;

    this.AccountOrSchoolLogoRef = clientReference;

    if(clientReference==null || clientReference==''){
      this.AccountOrSchoolLogo = '';
      this.AccountLogoShape = '';
    }
    else{
      this.schoolService.getLogo(clientRefType,clientReference)
        .subscribe((response: any) => {
          var accountLogo = response?.dsh_logo_url;
          var logoShape = response?.dsh_logo_shape;
          this.AccountOrSchoolLogo = accountLogo;
          this.AccountLogoShape = logoShape
        });
    }
  }

  requestAccessForModuleAndSubcategory() {
    this.router.navigate(['/requestAccess']);
    this.currentRoute = this.sideMenu.RequestAccess;
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }

  getSectorName(): string {
    this.selectedSector = parseInt(sessionStorage.getItem('sector')!);
    this.sectorName = this.sectors.find(s => s.sectorId === this.selectedSector)?.sectorName!;
    let sectorValue = this.sectorName ? ("Sector (" + this.sectorName + ")") : "Sector"
    return sectorValue;
  }

  onSelectingSector() {
    this.router.navigate(['/sector'],{
      state: {
        userId: this.userRole.includes(this.roles.AccountAdmin) ? this.userId : 0 //Filter sector only for account admin
      }
    });
    this.sharedService.setLocalStorageValueOfSector("0");

    sessionStorage.removeItem('client_account');
    sessionStorage.removeItem('client_reference');
    sessionStorage.removeItem('package_of_client_account');
    sessionStorage.removeItem('my_ref_school_id');
    sessionStorage.removeItem('school_id');
    this.currentRoute = this.sideMenu.Sector;
  }
  
  handleReportViewChanges(reportView: DtoUserReportView, hint: string | null = null){
    var auth = this.sharedService.getLoginToken()
    this.reportService.GetUserReportViews(auth.userId, reportView.subCategoryId,true)
    .subscribe({
      next:(response: DtoUserReportView[])=>{
          this.selectedSubCategory!.userReportViews = response;
          var startup = response.find((x)=>x.isStartup);
          if(startup)
            this.selectedSubCategory!.defaultUserReportViewId = startup.userReportViewId;

          this.selectedSubCategory!.userReportViewId = reportView.userReportViewId;

      },
      error:(err)=>{
        this.toasterService.error('Error loading report views','Error');
      }
    });

    
  }

  handleUserProfileChange(userProfile: DtoUserProfile, hint: string | null){
    if(hint==null || hint=='startupSubcategory')
    {
      this.startupSubCategoryId = userProfile?.startupSubcategory;
      this.startupSubPageName = userProfile?.pageName;
    }
  }

  getStartupPage():number|null{
    var userProfile = this.sharedService.getUserProfile();
    this.startupSubCategoryId = userProfile?.startupSubcategory;
    
    this.startupSubPageName = userProfile?.pageName;
    
  
    return this.startupSubCategoryId;
  }

  findModuleByPackageSubCategoryId(packageSubCategoryId: number): 
  {
    module: DtoModuleSubcategory
    subcategory: DtoSubCategory
  } | null
  {
    var foundSubCategory: DtoSubCategory | null = null;
    for (let module of this.package.modules) 
    {
      foundSubCategory = module.subCategories
                          .find(sc => sc.packageSubCategoryId === packageSubCategoryId)??null;
      if (foundSubCategory){
        return {
          module: module,
          subcategory: foundSubCategory
        };
      }
    }

    return null;
  }

  get NonFavoriteCount():number
  {
    const data = this.selectedSubCategory;
    if(data==null) return 0;

   if(data.userReportViews==null) return 0;

   return data.userReportViews.filter(x=>!x.isFavourite).length
  }

  goToStartupPage(){
    var startupSubCategoryId: number | null = null;
    startupSubCategoryId = this.getStartupPage();

    var startupSubcategory: DtoSubCategory|null=null;
    var hasStartup: boolean = (startupSubCategoryId!=null && startupSubCategoryId>0);
    
    if( this.package.modules.length > 0
        && this.package.modules[0].subCategories.length > 0)
    {
      const firstModule = this.package.modules[0];
      const firstToolkit = firstModule.subCategories[0];
      this.selectedSubCategory = firstToolkit;

      if(startupSubCategoryId==null){
        startupSubCategoryId = firstToolkit.packageSubCategoryId;
      }
        
      var foundEntry  = startupSubCategoryId==0?null:this.findModuleByPackageSubCategoryId(startupSubCategoryId!);
      
      if(!foundEntry){
        hasStartup=false;
        foundEntry = this.findModuleByPackageSubCategoryId(firstToolkit.packageSubCategoryId!);
        if(startupSubCategoryId!=0)
        {
          startupSubCategoryId=0;//landing page
          //this.toasterService.warning('Your startup toolkit is no longer valid.','Toolkit Preferences');
        }
      }

      if(foundEntry!=null)
      {
        foundEntry.subcategory.isStartUp=hasStartup;
        
        foundEntry.module.isExpanded = true;
        const sg = foundEntry.module.subCategoryGrouping?.find(sg=>sg.items.find(sc=>sc.packageSubCategoryId==foundEntry?.subcategory.packageSubCategoryId));
        if(sg) sg.isExpanded=true;
        startupSubcategory = foundEntry.subcategory;
      }
    }
    else
    {
      startupSubCategoryId=0;
    }

    if(startupSubcategory==null)
      this.goToLandingPage(true);
    else
      this.goToDashboard(startupSubcategory, startupSubCategoryId==0);

    this.currentRoute = this.sideMenu.Dashboard;
    this.showDynamicMenu = true;
    this.router.navigate(['/dashboard']);
    this.currentRoute = this.sideMenu.Dashboard;
  }

  goToLandingPage(forceOpen=false) {
    // Landing page button is a toggle. 
    // When OFF it should do to the normal page
    if(forceOpen==false && this.selectedSubCategory==null)
    {
      
      //LANDING PAGE: OFF
      //maintain the squece of call
      this.selectedSubCategory = this.prevSelectedSubCategory;
      //this.sharedService.setReportId(this.selectedSubCategory);
      this.goToDashboard(this.selectedSubCategory!, false);
      this.prevSelectedSubCategory = null;

    }
    else{
      //Landing page: ON
      const savedSelectedSubCategory = this.selectedSubCategory;
      //maintain the squece of call
      this.selectedSubCategory = null;
      this.sharedService.setReportId(this.package,savedSelectedSubCategory,'landingpage');
      this.prevSelectedSubCategory = savedSelectedSubCategory;
      
    }
  }

  get OwnsUserView(){
    if(this.selectedSubCategory==null) return true;

    const userReportViewId = this.selectedSubCategory.userReportViewId??0;
    if(userReportViewId==0) return true;

    const urv = this.selectedSubCategory.userReportViews!.find((x)=>x.userReportViewId==userReportViewId);
    if(urv==null) return false;

    return (urv.subCategoryId==this.selectedSubCategory.subCategoryId);
  }
  
  goToDashboard(subCategory: DtoSubCategory, forceLandingPage:boolean=false) {
    
    this.selectedSubCategory = subCategory;
    this.prevSelectedSubCategory = subCategory;

    var thisSubcategory =  this.selectedSubCategory;
    var auth = this.sharedService.getLoginToken();
    
    this.reportService.GetUserReportViews(auth.userId, 
      this.selectedSubCategory.subCategoryId, true)
    .subscribe({
      next:(reportViews: DtoUserReportView[])=>{
        thisSubcategory.userReportViews = reportViews;
        var selectedViewId = 0;
        if(reportViews.length > 0){
          var firstView = reportViews.find(x=>x.isStartup);
          if(firstView!=null) selectedViewId = firstView.userReportViewId;
        }

        thisSubcategory.userReportViewId = selectedViewId;
        
        if((this.selectedSubCategory?.packageSubCategoryId==this.startupSubCategoryId) && this.selectedSubCategory!.userReportViewId==0){

          this.selectedSubCategory!.startupPageName = this.startupSubPageName;
        }
        else{
          this.selectedSubCategory!.startupPageName = null;
        }

        if(forceLandingPage)
          this.goToLandingPage(true);
        else
          this.sharedService.setReportId(this.package, thisSubcategory);
      },
      error:(err)=>
      {
        this.toasterService.error('Error loading report views', 'Error')

        thisSubcategory.userReportViews=[];
        thisSubcategory.userReportViewId=0;
        this.sharedService.setReportId(this.package, subCategory);
      }
    });    
  }

  getSectors(){
    this.sectorService.getSectors().subscribe((response: DtoSector[] | any) => {
      this.sectors = response;
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  logout() {
    this.sharedService.logout();
  }

  getClaims() {
    
    const decodedToken = this.sharedService.getLoginToken()

    // Access role claim
    let role = decodedToken?.role;
    this.userName = decodedToken?.unique_name;
    this.assignedPackageId = decodedToken?.assignedPackageId;
    this.roleName = decodedToken?.roleName;


    sessionStorage.setItem('user_role', role);
    sessionStorage.setItem('user_email', decodedToken?.email);
    sessionStorage.setItem('packageId', this.assignedPackageId.toString());
    sessionStorage.setItem("orgType", decodedToken?.orgType),
    sessionStorage.setItem("orgRef", decodedToken?.orgRef)
    sessionStorage.setItem("client_reference", decodedToken?.orgRef)

    if(decodedToken?.orgType==='ORG'){
      sessionStorage.setItem("my_ref_school_id", decodedToken?.orgRef);
      sessionStorage.setItem("school_id", decodedToken?.orgId);

      if(decodedToken?.clientAccountId && decodedToken?.clientAccountId > 0)
      {
        sessionStorage.setItem("client_account", decodedToken?.clientAccountId);
      }
      else{
        sessionStorage.removeItem("client_account");
      }
    }
    else{
      sessionStorage.removeItem("school_id");
    }

    // Get Sector Claim
    this.sectorId = decodedToken?.sector;
    this.userId = decodedToken?.userId;
    sessionStorage.setItem('user_id', decodedToken?.userId);
    this.schoolId = decodedToken?.schoolId?.split(',').filter((id: string) => id.trim() !== '').join(',');
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    
  }

  initUserContetext(){
    this.getUserDetails();

    this.loadReportData(this.sectorId);
  }

  loadReportData(sectorId: any, validateReport: boolean = false, checkIfClientAccountIsSelected: boolean = false) {
    
    this.package = {} as PackageInformation;
    if(!this.schoolId && validateReport &&
      !this.userRole?.includes(this.roles.SuperAdmin) &&
      !this.userRole?.includes(this.roles.AccountAdmin)){
      this.toasterService.warning('There is no school associated with your account. Please contact the administrator!');
      this.showDynamicMenu = false;
      return;
    }

    if(checkIfClientAccountIsSelected){
      if((this.userRole.includes(this.roles.SuperAdmin) || this.userRole.includes(this.roles.AccountAdmin)) &&
        !sessionStorage.getItem('client_account') &&
        !sessionStorage.getItem('my_ref_school_id')) {
        this.toasterService.warning('Please click on "View My Insights" in action column of any client account/independent school to view reports');
       //todo: comment out
        this.currentRoute = this.sideMenu.UserCenter;
        this.router.navigate(['/userCenter']);
        return;
      }
    }

    this.showDynamicMenu = validateReport;
    //Mat Admin
    if(this.userRole?.includes(this.roles.MatAdmin)){
      if(validateReport){ //Call only when My Insights is clicked
        this.getPackageByPackageId(this.assignedPackageId);
        return;
      }
      this.showDynamicMenu = false;
      this.currentRoute = this.sideMenu.AdminDetailsCenter;
      this.sharedService.setLocalStorageValueOfSector("1");
      this.router.navigate(['/adminDetails']);
      return;
    }

    //School Admin
    if(this.userRole?.includes(this.roles.SchoolAdmin)){
      if(validateReport){ //Call only when My Insights is clicked
        this.getPackageByPackageId(this.assignedPackageId);
        return;
      }
      this.showDynamicMenu = false;
      this.currentRoute = this.sideMenu.SchoolBasicDetails;
      this.sharedService.setLocalStorageValueOfSector("1");
      this.router.navigate(['/schoolBasicDetails']);
      return;
    }

    //School User
    if(!this.userRole?.includes(this.roles.SuperAdmin) &&
      !this.userRole?.includes(this.roles.AccountAdmin) &&
      !this.userRole?.includes(this.roles.SchoolAdmin)){
      this.sharedService.setLocalStorageValueOfSector("1");
      this.loggedInAsSchoolUser = true
      this.getPackageForSchoolUsers();
      return;
    }

    //sectorId > 0 -> Account Admin, else -> Super Admin
    if(Number(sessionStorage.getItem('package_of_client_account')) > 0){
      this.getPackageByPackageId(Number(sessionStorage.getItem('package_of_client_account')));
    }
    else{
      if(sectorId==0){
        this.currentRoute = this.sideMenu.Sector;
        this.getPackageByPackageId(this.assignedPackageId);
        
        this.router.navigate(['/sector'],{
          state: {
            userId: parseInt(sectorId) > 0 ? this.userId : 0 //Filter sector only for account admin
          }
        });
      }
      else{
        this.sharedService.setLocalStorageValueOfSector("1");
        this.currentRoute = this.sideMenu.UserCenter;
        this.router.navigate(['/userCenter']);
      }
      
    }
  }

  getPackageByPackageId(assignedPackageId: number) {
    if(!Number(assignedPackageId)){
      return;
    }

    const clientReference = sessionStorage.getItem('client_reference');

    if (!clientReference) {
      return;
    }

    this.packageService.GetPackageInformationForClient(clientReference,assignedPackageId).subscribe(
      (response: PackageInformation | any)=>
        {
          this.package = response;
          this.package?.modules?.forEach((module: any) => {
            module.isExpanded = false;
            module.subCategoryGrouping =  this.getSubCategoryGrouping(module.subCategories);
          });
          this.goToStartupPage();
      
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
      this.package={} as PackageInformation;
      this.goToStartupPage();
    });
  }

  handleBack(){
    this.showDynamicMenu=false;
    const client_account_id = Number(sessionStorage.getItem('client_account')??0);

    sessionStorage.removeItem('package_of_client_account');
    sessionStorage.removeItem('client_account');
    sessionStorage.removeItem('client_reference');
    sessionStorage.removeItem('package_of_client_account');
    sessionStorage.removeItem('my_ref_school_id');
    sessionStorage.removeItem('school_id');
    this.getClaims();
    this.setClientLogo(null); 
    this.package = {} as PackageInformation;
    if(this.userRole?.includes(this.roles.MatAdmin)){
      this.currentRoute = this.sideMenu.AdminDetailsCenter;
      this.router.navigate(['/adminDetails']);
      return;
    }

    if(this.userRole?.includes(this.roles.SchoolAdmin)){
      this.currentRoute = this.sideMenu.SchoolBasicDetails;
      this.router.navigate(['/schoolBasicDetails']);
    }

    else{
      if(client_account_id > 0){
        this.currentRoute = this.sideMenu.UserCenter;
        this.router.navigate(['/userCenter']);
      }
      else{
        this.currentRoute = this.sideMenu.IndependentSchool;
        this.router.navigate(['/independentSchool']);
        
      }
    }
  }

  getPackageForSchoolUsers() {

    const clientReference = sessionStorage.getItem('client_reference');

    if (!clientReference) {
      return;
    }

    this.packageService.getPackageInformationForClientAndRole(clientReference,
      sessionStorage.getItem('user_role')!).subscribe((response: PackageInformation | any)=>{
      this.package = response;
      
      this.package?.modules?.forEach((module: any) => {
        module.isExpanded = false;
        module.subCategoryGrouping =  this.getSubCategoryGrouping(module.subCategories);
      });
      
      this.goToStartupPage();
      
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
      this.goToStartupPage();
    });
  }

  getUserDetails(){
    this.loginService.getUserDetails(this.userId.toString())
    .subscribe(
      {
        next: dtoUser=>{
            this.loginService.getDocumentApi(dtoUser.profileUrl!)
                    .subscribe({
                      next: blob =>{
                          this.url = URL.createObjectURL(blob);
                      },
                      error: err =>{
                          this.url = '';
                      }
                    });
        }
      });
  }

  toggleModule(module: any) {
    let currentState = { ...module };
    let isAnyModuleExpanded = this.package?.modules?.some((mod: any) => mod.isExpanded == true);
    if(isAnyModuleExpanded){
      this.package?.modules?.forEach((element:DtoModuleSubcategory)=> element.isExpanded = false);
    }
    module.isExpanded = !currentState.isExpanded;
    this.cdr.detectChanges();
  }
  navigateToNotifications() {
    this.currentRoute = "";
    this.showDynamicMenu = false;
    if(Number(sessionStorage.getItem('client_account')) > 0){
      sessionStorage.removeItem('client_account');
    }
    if(sessionStorage.getItem('my_ref_school_id')){
      sessionStorage.removeItem('my_ref_school_id');
      sessionStorage.removeItem('school_id');
    }
    this.router.navigate(['/notifications']);
  }

  navigateToProfile() {
    this.currentRoute = "";
    this.showDynamicMenu = false;
    this.router.navigate(['/profile']);
  }

  fetchNotifications(loggedInUser: string, includeHolding: boolean=true) {
    this.notificationCount = -1;
    this.notificationService.fetchNotificationCount(loggedInUser, 0)
      .subscribe({
        next: (response: DtoNotificationCount) => {
          this.notificationCount =
            response.messageCount +
            response.alertCount +
            response.systemMessageCount;

          this.snackBar.dismiss();

          if(includeHolding)
          {
            this.sharedService.setHoldingState(
              response.underMaintenance,
              response.holdingDate
            );
          }

          if (includeHolding==false || response.holdingDate == null) {
            if (response.alertCount > 0 || response.systemMessage != null || response.accountMessage != null) {
              this.showDataAlert(
                response.systemMessage,
                response.accountMessage,
                response.alertMessage
              );
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });

  }

  showDataAlert(systemMessage:string|null, accountMessage:string|null, alertMessage:string|null) {
    if(systemMessage==null && accountMessage==null && alertMessage==null) return;

    let messages: string[] = [];
    if(systemMessage!=null)
      messages.push(systemMessage)

    if(accountMessage!=null)
      messages.push(accountMessage)

    if(alertMessage!=null)
      messages.push(alertMessage)

    if(messages.length>0)
      this.snackbar(messages, 1, messages.length);
  }

  snackbar(messages: string[], messageNumber:number, totalMessages: number){
    if(messages.length==0) return;

    const [firstMessage, ...restOfThem] = messages;
    let buttonText = 'Dismiss';
    if(restOfThem.length>0)
      buttonText =  `(${messageNumber} of ${totalMessages}) Next`
    
    const snackBarRef = this.snackBar.open(firstMessage, 
          buttonText, 
          {
            duration: 0,
            panelClass: ['alert-snackbar'],
            horizontalPosition: 'center'
        });
        
    if(restOfThem.length>0)
    {
      snackBarRef.afterDismissed().subscribe(() => {
        // Show the next snackbar here
        this.snackbar(restOfThem, ++messageNumber, totalMessages);
      });
    }
  }

    dashboardAction(command: string, args: number|string|null=null){
      
      
      if(command=='loadview'){
        this.selectedSubCategory!.userReportViewId = Number(args);

        if((this.selectedSubCategory?.packageSubCategoryId==this.startupSubCategoryId) && this.selectedSubCategory!.userReportViewId==0){

          this.selectedSubCategory!.startupPageName = this.startupSubPageName;
        }
        else{
          this.selectedSubCategory!.startupPageName = null;
        }

        this.sharedService.setReportId(this.package,this.selectedSubCategory,'loadview');
      }
      else if(command ==='startupReport'){
        this.selectedSubCategory!.isStartUp = !this.selectedSubCategory!.isStartUp;
        this.sharedService.triggerDashboardActionCommand(command,args);
      }
      else{
        this.sharedService.triggerDashboardActionCommand(command,args);
      }
    }
    
    changeContrastMode(mode: ContrastMode) {
      
      this.sharedService.setContrastMode(mode);
      
    }

}


export enum SideMenu {
  AccountAdminCenter = '/accountAdminCenter',
  UserCenter = '/userCenter',
  PackageCenter = '/packageCenter',
  DataManagementCenter = '/dataManagement',
  PackageDetails = '/packageDetails',
  AdminDetailsCenter = '/adminDetails',
  SchoolBasicDetails = '/schoolBasicDetails',
  IndependentSchool = '/independentSchool',
  UserRole = "/userRole",
  UserDetails= '/userDetails',
  SchoolDetails= '/schoolList',
  Sector = '/sector',
  Dashboard = '/dashboard',
  TicketManagement = '/ticketManagement',
  RequestAccess = '/requestAccess',
  ErrorLog = '/errorLog',
  TraceReport = '/traceReport',
  SystemMessageSettings = '/systemMessages',
}
